export default __webpack_public_path__ + "static/media/accessDenied.ba3920fe.png";